import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Cell } from 'react-foundation';

const DemoFilterComponent = ({ filterText, filterStatus, onFilterText, onFilterStatus, onClear }) => (
  <form className="conversations-filter-form">
    <Grid className="grid-padding-x align-justify">
      <Cell small={6}>
        <input
          type="search"
          value={filterText}
          onChange={onFilterText}
          required={true}
          placeholder="Search by Name..."
          className="conversations-filter-form__input"
          data-demo-id="demo-search-input"
        />
      </Cell>

      <Cell small={4}>
        <select
          value={filterStatus}
          onChange={onFilterStatus}
          className="conversations-filter-form__filter"
          data-demo-id="demo-filter-select"
        >
          <option value="">Filter by Status</option>
          <option value="0">Not Started</option>
          <option value="1">In Progress</option>
          <option value="2">Complete</option>
        </select>
      </Cell>

      <Cell small={2}>
        {(filterStatus || filterText) && (
          <button
            onClick={onClear}
            className="conversations-filter-form__button"
            data-demo-id="demo-clear-button"
          >
            Clear filter
          </button>
        )}
      </Cell>
    </Grid>
  </form>
);

DemoFilterComponent.propTypes = {
  filterText: PropTypes.string,
  filterStatus: PropTypes.string,
  onFilterText: PropTypes.func,
  onFilterStatus: PropTypes.func,
  onClear: PropTypes.func
};

export default DemoFilterComponent;
